export default __webpack_public_path__ + "static/media/Background_00081.67ae501a.png";